import { useBlockProps } from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';
import InspectorGenerator from '../functions/InspectorGenerator';
import blockJson from './block.json';
import InfoBoxWrapper from '../html/src/info-box/InfoBoxWrapper';
import Style from './Style';

export default function Edit( props ) {
	const { attributes, setAttributes, isSelected, clientId } = props;
	const { blockId } = attributes;

	useEffect( () => {
		setAttributes( { blockId: clientId } );
	}, [ clientId ] );

	const blockProps = useBlockProps( {
		className: `alpha-info-box-blocks alpha-info-box-block-${ blockId }`,
	} );

	return (
		<div { ...blockProps }>
			<Style { ...props } blockId={ blockId } />
			{ isSelected && (
				<InspectorGenerator props={ props } blockJson={ blockJson } />
			) }
			<InfoBoxWrapper attributes={ attributes } />
		</div>
	);
}
